import React, { Component } from 'react';
import {connect} from 'react-redux';
import { insertSecSubQuestion, emptyDemoSubQuestionResponse,emptyDemoSecSubQuestionResponse} from '../../actions/demographics';
import AddSecSubQuestion from '../../components/demographics/addSecSubQuestion';

class AddDemographicsSecSubQuestion extends Component {
  constructor(props){
    super(props)

    // this.queryString = window.location.href;

    // if (this.queryString !== "") {
    //   this.catID = this.queryString.split('&c:')[1];  //participant id 
    // }

    this.state={
        editCategoryPageData : "",
       // catID : this.catID
    };
    this.insertSecSubQuestion = this.insertSecSubQuestion.bind(this);
    this.emptyDemoSecSubQuestionResponse = this.emptyDemoSecSubQuestionResponse.bind(this);
  }

  insertSecSubQuestion(data){
      this.props.dispatch(insertSecSubQuestion(data));
  }

  componentDidMount(){
    if(this.props.location.state){
        const { editCategoryItemData } = this.props.location.state;

      if(editCategoryItemData){
          this.setState({
            editCategoryPageData : editCategoryItemData
        });
      }
    }
  }

  emptyDemoSecSubQuestionResponse(){
      this.props.dispatch(emptyDemoSecSubQuestionResponse());
  }
  
  render(){

    let showAddDemographicsCategoriesSubQuestionView = <AddSecSubQuestion
        insertSecSubQuestion = {this.insertSecSubQuestion}
        demoGraphicsSecSubQuestionAddSuccess = {this.props.demoGraphicsSecSubQuestionAddSuccess}
        demoGraphicsSecSubQuestionSuccessmessage = {this.props.demoGraphicsSecSubQuestionSuccessmessage}
        demoGraphicsSecSubQuestionFailmessage = {this.props.demoGraphicsSecSubQuestionFailmessage}

        emptyDemoSecSubQuestionResponse = {this.emptyDemoSecSubQuestionResponse}
    />
      
    return (
        <div> 
             {showAddDemographicsCategoriesSubQuestionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsSecSubQuestionAddSuccess     : state.demographics.demoGraphicsSecSubQuestionAddSuccess,
    demoGraphicsSecSubQuestionSuccessmessage : state.demographics.demoGraphicsSecSubQuestionSuccessmessage,
    demoGraphicsSecSubQuestionFailmessage    : state.demographics.demoGraphicsSecSubQuestionFailmessage,    
  }
}

export default connect(mapStateToProps)(AddDemographicsSecSubQuestion);



// WEBPACK FOOTER //
// ./src/pages/demographics/addDemoSecSubQuestion.js